import React, { FC } from 'react'
import { Div, Spacer, Text } from '@sendoutcards/quantum-design-ui'
import { PromptingsLogoSVG } from './PromptingsLogoSVG'
import { Button } from 'src/design_system/components/Button'
import { UpsaleBackground } from './constants'

const styles = {
  background: {
    position: 'fixed' as const,
    width: '100vw',
    height: '100vh',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(215,215,215,0.75)',
    zIndex: 1000,
  },
  modal: {
    display: 'flex',
    flexDirection: 'column' as const,
    width: 'min(1000px, 60vw)',
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '16px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    boxShadow: '0px 0.25rem 1.5rem rgba(0, 0, 0, 0.25)',
  },
  image: {
    width: '200px',
    alignSelf: 'center',
    justifySelf: 'center',
    '@media (max-width: 800px)': {
      width: '90%',
    },
  },
  actions: {
    marginTop: '2rem',
    '@media (max-width: 800px)': {
      marginTop: '0px',
      flexDirection: 'column' as const,
      justifySelf: 'center',
      alignItems: 'center',
    },
  },
  or: {
    fontFamily: "'Montserrat', sans-serif",
    fontSize: '2rem',
    fontStyle: 'italic',
    fontWeight: 700,
    color: '#FFF',
    textAlign: 'center' as const,
    '@media (max-width: 800px)': {
      fontSize: '1.5rem',
    },
  },
}

type PromptingsPackageUpsaleProps = {
  sponsorId?: string
  isMobile?: boolean
  onBlankAreaClick: () => void
}

export const PromptingsPackageUpsaleModal: FC<PromptingsPackageUpsaleProps> = ({
  sponsorId,
  isMobile,
  onBlankAreaClick,
}) => {
  const blurSite = '#site {filter: blur(4px); }'

  const handleNewUser = async () => {
    window.open(
      `https://shop.bydesign.com/SendOutCards/#/shop/detail/15186/from/${sponsorId}?MarketShow=550`,
    )
  }

  const handleSOCUser = () => {
    window.open(
      'https://app.sendoutcards.com/dashboard/pricing?goToPricing=true',
    )
  }

  const standardButtonProps = {
    textSize: '1rem',
    textWeight: 700,
    width: '160px',
    padding: '1rem',
  }

  return (
    <Div css={styles.background} onClick={onBlankAreaClick}>
      <style children={blurSite} />
      <Div
        css={styles.modal}
        backgroundImage={`data:image/png;base64, ${UpsaleBackground}`}
        backgroundColor="blue"
        inset="x4"
      >
        <Div css={styles.image} position="relative">
          <PromptingsLogoSVG />
          <Spacer space="x2" />
        </Div>
        <Div>
          <Text
            type={isMobile ? 'largeBody' : 'title'}
            content="Before we continue, are you?"
            alignment="center"
            weight="extraBold"
            color="accent"
          />
          <Spacer space="x4" />
        </Div>
        <Div
          css={styles.actions}
          display="flex"
          columnGap="x2"
          justifyContent="center"
        >
          <Button
            {...standardButtonProps}
            title="New User"
            onClick={handleNewUser}
            backgroundColor="#4DDFDF"
          />
          <span css={styles.or}>Or</span>
          <Button
            {...standardButtonProps}
            title="SOC User"
            onClick={handleSOCUser}
            backgroundColor="transparent"
            outlineColor="#FFF"
            outlineWidth="2px"
          />
        </Div>
      </Div>
    </Div>
  )
}
